//============================================================
// appsolut Theme VIENNA - v1.0.0
//============================================================
//
// Based on Otis Kit PRO - v2.0.1 from www.creative-tim.com
//
//============================================================

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

// Custom styles for StyledInput
import InputRoot from './InputRoot';

const StyledInput = forwardRef(({ error, success, disabled, ...rest }, ref) => (
  <InputRoot {...rest} ref={ref} ownerState={{ error, success, disabled }} />
));

// Setting default values for the props of StyledInput
StyledInput.defaultProps = {
  error: false,
  success: false,
  disabled: false,
};

// Typechecking props for the StyledInput
StyledInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default StyledInput;
